import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Title from "segments/desktop/core-components/title/title";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";
import { StyledProductCardContent } from "./product-card-content.scss";
import ProductCardUseCases from "./product-card-use-cases/product-card-use-cases";
const ProductCardContent = ({ title, body, titleWidth, useCasesWidth, useCases, textWidth, productColor, isUseCasesReadonly, productType, showUseCasesVertically, spaceUnderTitle })=>/*#__PURE__*/ _jsxs(StyledProductCardContent, {
        className: "product-card-content",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "title-container",
                style: {
                    marginBottom: spaceUnderTitle,
                    maxWidth: titleWidth
                },
                children: /*#__PURE__*/ _jsx(Title, {
                    title: title,
                    titleClassName: "content-title"
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "use-cases-wrapper",
                style: {
                    maxWidth: useCasesWidth
                },
                children: [
                    /*#__PURE__*/ _jsx(Paragraph, {
                        textWidth: textWidth,
                        body: body
                    }),
                    /*#__PURE__*/ _jsx(ProductCardUseCases, {
                        productColor: productColor,
                        productType: productType,
                        useCases: useCases,
                        isUseCasesReadonly: isUseCasesReadonly,
                        showUseCasesVertically: showUseCasesVertically
                    })
                ]
            })
        ]
    });
export default ProductCardContent;
